<div class="editor-host">
  <div
    gstarRichEditor
    [content]="sanitizedHtml()"
    [fileName]="title()"
    [mode]="mode()"
    (loaded)="loadedHandler($event)"
    [class.d-none]="activeEditorState() !== editorStates.isLoaded"></div>
  @if (internalLinkInsertionRange()) {
    <div #innerLinksPicker class="inner-links-picker" role="listbox">
      <p class="inner-links-picker-title">
        {{ 'shared.editor.innerLinks.title' | translate }}
      </p>
      <div class="inner-links-picker-content">
        @if (!countryId()) {
          <p class="inner-links-picker-empty">
            {{ 'shared.editor.innerLinks.noCountry' | translate }}
          </p>
        } @else if (innerLinkGroups().length === 0) {
          <p class="inner-links-picker-empty">
            {{ 'shared.editor.innerLinks.noMatches' | translate }}
          </p>
        } @else {
          @for (group of innerLinkGroups(); track group.name) {
            <div class="inner-links-picker-group" role="group">
              <p class="inner-links-picker-group-title">
                {{ group.name }}
              </p>
              @for (section of group.sections; track section.id) {
                <button
                  type="button"
                  class="inner-links-picker-item"
                  (mousedown)="$event.preventDefault()"
                  (click)="insertInnerLink(section)">
                  {{ section.name }}
                </button>
              }
            </div>
          }
        }
      </div>
    </div>
  }
</div>
@if (activeEditorState() === editorStates.hasError) {
  <p>{{ 'shared.editor.editorError' | translate }}</p>
} @else if (activeEditorState() === editorStates.isBuilding) {
  <div class="d-flex justify-content-center align-items-center h-100">
    <div>
      <ap-loading
        loadingType="circular"
        class="align-self-start mt-2"
        [indeterminate]="true"
        [compact]="true" />
      <p class="mt-2">{{ 'shared.editor.editorLoading' | translate }}</p>
    </div>
  </div>
}
